module.exports = __webpack_public_path__ + "static/media/icon_access_denied.8b9b2f9c.png";